import React from 'react';

function CautionRailwayIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M12.5021 13.5673L6.18803 20L4.14744 17.9102L8.41026 13.5673H12.5021Z" />
      <path d="M19.8526 6.07891L15.5897 10.4218H11.4979L17.8013 4L19.8526 6.07891Z" />
      <path d="M12.5021 10.4218H8.41026L4.14744 6.07891L6.18803 4L12.5021 10.4218Z" />
      <path d="M19.8526 17.9102L17.8013 20L11.4979 13.5673H15.5897L19.8526 17.9102Z" />
      <path d="M22 11.6082H2V12.381H22V11.6082Z" />
      <path d="M3.86331 10.8467L3.07273 10.8511L3.08481 13.1259L3.87539 13.1215L3.86331 10.8467Z" />
      <path d="M6.26712 10.8553L5.47654 10.8596L5.48862 13.1344L6.2792 13.1301L6.26712 10.8553Z" />
      <path d="M8.67094 10.8529L7.88036 10.8572L7.89244 13.132L8.68303 13.1277L8.67094 10.8529Z" />
      <path d="M11.1068 10.8503L10.3162 10.8547L10.3283 13.1295L11.1189 13.1251L11.1068 10.8503Z" />
      <path d="M13.532 10.8586L12.7414 10.863L12.7535 13.1378L13.5441 13.1334L13.532 10.8586Z" />
      <path d="M15.9572 10.8563L15.1666 10.8606L15.1786 13.1354L15.9692 13.1311L15.9572 10.8563Z" />
      <path d="M20.7648 10.8514L19.9742 10.8558L19.9863 13.1306L20.7769 13.1262L20.7648 10.8514Z" />
      <path d="M18.3889 10.8514L17.5983 10.8558L17.6104 13.1306L18.401 13.1262L18.3889 10.8514Z" />
    </svg>
  );
}

export default CautionRailwayIcon;

